var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slot-shadow rounded-2xl px-6 py-3 bg-white flex justify-start items-center cursor-pointer",on:{"click":function($event){return _vm.$emit('click')}}},[_c('p',{staticClass:"font-semibold text-18 w-24",class:_vm.arabic ? 'ml-10' : 'mr-10',attrs:{"dir":"ltr"}},[_vm._t("default")],2),_c('IconCircleArrowRight')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }